import track from './track';

export default function formTracking(form) {
    return track({
        ...form,
        DSEakpzeptiert: true,
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/form.js